var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 16,
    fill: "#00A868",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2684 13.0319C12.2268 12.99 12.1771 12.957 12.1224 12.9342C12.068 12.9117 12.0095 12.9 11.9503 12.9C11.8911 12.9 11.8326 12.9117 11.7782 12.9342C11.7235 12.957 11.674 12.99 11.6321 13.0319L9.03945 15.8898C8.88555 16.0557 8.80005 16.2735 8.80005 16.4996C8.80005 16.7257 8.88555 16.9435 9.03945 17.1094V17.1109L11.6321 19.9684C11.6951 20.0314 11.7755 20.0742 11.8628 20.0915C11.9501 20.1088 12.0405 20.0998 12.1229 20.0656C12.205 20.0314 12.2752 19.9736 12.3247 19.8996C12.374 19.8256 12.4003 19.7385 12.4003 19.6494V13.3489C12.4001 13.2301 12.3526 13.116 12.2684 13.0319Z",
    fill: "#00A868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.2695C16.0002 23.3282 16.0122 23.3865 16.0356 23.4403C16.059 23.4943 16.0929 23.5429 16.1357 23.5831C16.1784 23.6234 16.2291 23.6545 16.2842 23.6745C16.3393 23.6945 16.398 23.7028 16.4565 23.6992C20.2201 23.4619 23.2 20.3301 23.2 16.5001C23.2 12.6701 20.2199 9.53697 16.4565 9.30094C16.398 9.29711 16.3393 9.30567 16.2842 9.32547C16.2288 9.34549 16.1782 9.37654 16.1355 9.41682C16.0927 9.45709 16.0587 9.50569 16.0353 9.55969C16.0121 9.61369 16 9.67197 16 9.73069V12.4318C16.0009 12.5531 16.0464 12.6699 16.1276 12.7597C16.2088 12.8497 16.32 12.9066 16.4403 12.9194C17.3118 13.0279 18.1134 13.4515 18.6948 14.1108C19.2762 14.7701 19.5971 15.6194 19.5971 16.4992C19.5971 17.3787 19.2762 18.2281 18.6948 18.8874C18.1134 19.5466 17.3118 19.9703 16.4403 20.0787C16.3202 20.0918 16.2088 20.1487 16.1276 20.2385C16.0464 20.3285 16.0011 20.445 16 20.5663V23.2695Z",
    fill: "#00A868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoneLogo);
export default __webpack_public_path__ + "static/media/stone-logo.3107653e656f02353a27c54cb063726a.svg";
export { ForwardRef as ReactComponent };